'use client'

import {
  EHomeCategoryTab,
  HomePageConstants,
} from '@/app/[locale]/(home)/_components/constants'
import { Button } from '@/components/ui/button'
import { useTranslations } from 'next-intl'
type Props = {
  onChangeTab: (tab: EHomeCategoryTab) => void
  selectedTab: EHomeCategoryTab
  homeType?: 'nam' | 'nu' | 'chung'
}

export const FilterButton: React.FC<Props> = ({
  onChangeTab,
  selectedTab,
  homeType,
}) => {
  const t = useTranslations('home_page.filter_button')

  return (
    <nav
      className='flex justify-start gap-4'
      role='navigation'
      aria-label='Category filters'
    >
      {HomePageConstants.categoryTabs.map((tab) => {
        // Format tracking value based on homeType
        const trackingValue =
          homeType === 'nam'
            ? `home-nam__category__filter__${tab.key.toLowerCase()}`
            : homeType === 'nu'
              ? `home-nu__category__filter__${tab.key.toLowerCase()}`
              : `home__category__filter__${tab.key.toLowerCase()}`

        return (
          <Button
            key={tab.key}
            size='large'
            variant={selectedTab === tab.key ? 'black' : 'neutral'}
            onClick={() => onChangeTab(tab.key)}
            ga-tracking-value={trackingValue}
            ga-tracking-label={t(tab.name)}
            className='px-6 py-3 max-lg:h-9 max-lg:py-2 max-lg:text-sm'
            aria-pressed={selectedTab === tab.key}
            aria-label={`Filter by ${tab.name}`}
          >
            <span>{t(tab.name)}</span>
          </Button>
        )
      })}
    </nav>
  )
}
